/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Supervisory_AuthorityInputs */

const en_privacy_supervisory_authority = /** @type {(inputs: Privacy_Supervisory_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayerisches Landesamt fuer Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Germany`)
};

const de_privacy_supervisory_authority = /** @type {(inputs: Privacy_Supervisory_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayerisches Landesamt fuer Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach`)
};

const fr_privacy_supervisory_authority = /** @type {(inputs: Privacy_Supervisory_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Allemagne`)
};

const es_privacy_supervisory_authority = /** @type {(inputs: Privacy_Supervisory_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Germany`)
};

const it_privacy_supervisory_authority = /** @type {(inputs: Privacy_Supervisory_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Germany`)
};

const nl_privacy_supervisory_authority = /** @type {(inputs: Privacy_Supervisory_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Duitsland`)
};

const pl_privacy_supervisory_authority = /** @type {(inputs: Privacy_Supervisory_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Germany`)
};

const fi_privacy_supervisory_authority = /** @type {(inputs: Privacy_Supervisory_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Germany`)
};

const da_privacy_supervisory_authority = /** @type {(inputs: Privacy_Supervisory_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayerisches Landesamt fuer Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Germany`)
};

const sv_privacy_supervisory_authority = /** @type {(inputs: Privacy_Supervisory_AuthorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayerisches Landesamt fuer Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Germany`)
};

/**
* | output |
* | --- |
* | "Bayerisches Landesamt fuer Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Germany" |
*
* @param {Privacy_Supervisory_AuthorityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_supervisory_authority = /** @type {((inputs?: Privacy_Supervisory_AuthorityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Supervisory_AuthorityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_supervisory_authority(inputs)
	if (locale === "fr") return fr_privacy_supervisory_authority(inputs)
	if (locale === "es") return es_privacy_supervisory_authority(inputs)
	if (locale === "it") return it_privacy_supervisory_authority(inputs)
	if (locale === "nl") return nl_privacy_supervisory_authority(inputs)
	if (locale === "pl") return pl_privacy_supervisory_authority(inputs)
	if (locale === "fi") return fi_privacy_supervisory_authority(inputs)
	if (locale === "da") return da_privacy_supervisory_authority(inputs)
	if (locale === "sv") return sv_privacy_supervisory_authority(inputs)
	return en_privacy_supervisory_authority(inputs)
});